module.exports = __webpack_public_path__ + "img/customer-w.svg";